import {
  FilterValue,
  PeriodFilterValue,
} from "../../shared/filters/types/filter";
import { isEmptyValue } from "./isEmptyValue";

const isPeriodFilterValue = (
  filterValue: FilterValue
): filterValue is PeriodFilterValue =>
  "startDate" in filterValue && "endDate" in filterValue;

const isDateString = (value: string) => /^\d{4}-\d{2}-\d{2}$/.test(value);

export function mapFilterValuesToObject(
  filterValues: FilterValue[]
): Record<string, string | boolean> {
  const filtersMap = filterValues.reduce(
    (
      accumulatedFilters: Record<string, string | boolean>,
      currentFilter: FilterValue
    ) => {
      if (isEmptyValue(currentFilter.value)) {
        return accumulatedFilters;
      }

      if (
        currentFilter.filterId === "period" &&
        currentFilter.value === "custom"
      ) {
        if (
          !isPeriodFilterValue(currentFilter) ||
          !isDateString(currentFilter.startDate) ||
          !isDateString(currentFilter.endDate)
        ) {
          return accumulatedFilters;
        }

        accumulatedFilters["period"] = "custom";
        accumulatedFilters["startDate"] = currentFilter.startDate;
        accumulatedFilters["endDate"] = currentFilter.endDate;
        return accumulatedFilters;
      }

      let value: string | boolean;

      if (currentFilter.value === null) {
        value = "null";
      } else if (Array.isArray(currentFilter.value)) {
        const arrayValue = currentFilter.value.join(",");
        if (!arrayValue) {
          return accumulatedFilters;
        }
        value = arrayValue;
      } else if (typeof currentFilter.value === "boolean") {
        value = currentFilter.value;
      } else {
        value = String(currentFilter.value);
      }

      accumulatedFilters[currentFilter.filterId] = value;
      return accumulatedFilters;
    },
    {} as Record<string, string | boolean>
  );

  return filtersMap;
}
